<!-- 
  進捗つきアラート
-->
<template>
  <div>
    <div class="fullview">
      <div class="container">
        <div class="row m-0 p-0 pt-4 align-items-center" style="height: 80px">
          <div class="col" style="width: 100px">
            <div class="progress m-auto">
              <div class="progress-bar pr" :style="styleVariables"></div>
            </div>
            <p class="m-0 mt-1 acry-text-sub" style="font-size: 12px;">{{Math.floor(this.$store.state.progress)}}％</p>
          </div>
        </div>
        <div class="row p-5">
          <div class="col justify-content-center pt-2">
            <img src="@/assets/acrypro/LoadingBar.svg" class="loading-anim" width="40" height="40">
          </div>
        </div>
        <div class="row">
          <!-- <div class="col justify-content-center pt-2 acry-text-title">
            {{this.$store.state.progressMessages[0]}}
            <p
              v-for="m in this.$store.state.progressMessages"
              :key="m"
              class="text-light text-center"
            >
              {{ m }}
            </p>
          </div> -->
          <p class="acry-text-title" style="font-size: 20px;">{{this.$store.state.progressMessages[0]}}</p>
          <p class="acry-text-body" style="font-size: 16px;">しばらくお待ちください</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "LoadingProgress",
  components: {
  },
  data() {
    return {};
  },
  methods: {
    okAction() {
      this.$store.commit("hideMessage");
    },
  },
  computed: {
    sendBytes() {
      return (this.$store.state.sendBytes / 1024 / 1024).toFixed(1);
    },
    /**
     * このコンポーネント中で用いるCSS変数をまとめる.
     * @return {object}
     */
    styleVariables() {
      let data = {
        "--p-width": "" + this.$store.state.progress + "%",
      };
      // console.log(data)
      return data;
    },
  },
};
</script>

<style scoped lang="scss">
.fullview {
  width: 100%;
  height: 100%;
  background: #000000aa;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.container {
  width:559px;
  z-index: 10001;
  padding: 40px;
  background-color: $background-gray-color;
  border-radius: 8px;
}
.progress {
  width: 322px;
  height: 26px;
  border-radius: 20px;
  background-color: $background-purplegray-color;
}
.progress-bar {
  border-radius: 20px;
  background-color: $primary-main-color;
}
.pr {
  width: var(--p-width);
}
.loading-anim{
  animation: rotate .7s linear infinite;
}
@keyframes rotate {
  0% {
    transform: rotateZ(0deg);
  }

  100% {
    transform: rotateZ(360deg);
  }
}
</style>
